import { useAtom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'
import { useGetPhoneNumber } from '~/queries/phoneNumberQueries'

import { PhoneNumber } from '@mangovoice/types'

import { StorageKeys } from './StorageKeys'

const lastUsedFaxNumberAtom = atomWithStorage<PhoneNumber | null>(
  StorageKeys.LastUsedFaxPhoneNumber,
  null,
)
const useLastUsedFaxNumber = (): [
  PhoneNumber | null,
  (phoneNumber: PhoneNumber | null) => void,
] => {
  const [lastUsedFaxNumber, setLastUsedFaxNumber] = useAtom(
    lastUsedFaxNumberAtom,
  )
  const lastUsedId = lastUsedFaxNumber?.id ?? 0
  const { data: lastUsedFaxPhoneNumber, isError } = useGetPhoneNumber({
    phoneNumberId: lastUsedId,
  })
  if (isError || !lastUsedFaxPhoneNumber) {
    return [null, setLastUsedFaxNumber]
  } else {
    return [lastUsedFaxPhoneNumber, setLastUsedFaxNumber]
  }
}

export { useLastUsedFaxNumber }
